import { connect } from "react-redux";
import { exportDialerReport, setEmptyTrafficStat, getDialerTrafficStat } from "actions/client/trafficStat";
import TrafficStat from "./TrafficStat";


const mapState = ({ client_traffic_stat, references }) => ({
    loading: client_traffic_stat.loading,
    page: client_traffic_stat.page,
    count: client_traffic_stat.count,
    trafficStat: client_traffic_stat.trafficStat,
    summaries: client_traffic_stat.summaries,
    uploadLoading: references.uploadLoadingDialer,
    globalSettings: references.global_setting,
    subdestinationList: references.subdestination_list
});

export default connect(mapState, {
    getTrafficStat: getDialerTrafficStat,
    exportReport: exportDialerReport,
    setEmptyTrafficStat
})(TrafficStat);
